import { combineReducers } from 'redux'
import AuthReducer from './AuthReducer'
import FiltrosReducer from './FiltrosReducer'
import PesqReducer from './PesqReducer'

export default combineReducers({
    auth: AuthReducer,
    pesq: PesqReducer
})
